/**
 * Tiny module-level registry so non-React code (api.service logout / 401 handler)
 * can trigger a graceful WebRTC teardown before clearing auth and redirecting.
 *
 * The NodeStreamProvider registers its shutdown fn on mount and clears it on
 * unmount. logout() / the 401 interceptor call runWebrtcTeardown() FIRST so the
 * ULLFU sessions are closed (bypassing the resume grace) rather than left to expire.
 */
type TeardownFn = () => void;

let teardownFn: TeardownFn | null = null;

export function registerWebrtcTeardown(fn: TeardownFn | null): void {
  teardownFn = fn;
}

export function runWebrtcTeardown(): void {
  try {
    teardownFn?.();
  } catch (err) {
    console.warn('[webrtc-teardown] teardown threw (ignored):', err);
  }
}
